import Tables from 'src/class/Tables';
import i18n from "src/i18n";

const configTable = () => {
    const Table = { ...Tables.Table };
    Table.tableColumns = [
        {
            prop: 'farm',
            label: i18n.t('common_words.farm'),
            minWidth: 100,
            sortable: true,
            align: 'center',
            fixed: true,
        },
        {
            prop: 'percentage',
            label: '% ' + i18n.t('common_words.shrinkage'),
            minWidth: 100,
            sortable: true,
            align: 'center',
            fixed: true,
        },
    ];
    const Search = { ...Tables.Search };
    return { Table, Search };
};

export default configTable;
